import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/726c23d556e856599d5a0590e4c2e305.jpg"
            alt="À propos de Grande Imprimerie"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <span className="inline-block bg-[#E63946]/20 text-[#E63946] px-6 py-2 rounded-full text-sm font-semibold mb-6">
            À PROPOS
          </span>
          <h1 className="text-white text-6xl lg:text-7xl font-black mb-6">
            GRANDE IMPRIMERIE
          </h1>
          <p className="text-gray-200 text-xl max-w-3xl mx-auto leading-relaxed">
            Votre partenaire de confiance pour tous vos besoins d'impression et de visibilité digitale depuis plus de 10 ans.
          </p>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20printing%20company%20modern%20facility%20high-tech%20printing%20equipment%20large%20format%20printers%20industrial%20workspace%20clean%20organized%20professional%20photography&width=800&height=600&seq=about-mission-001&orientation=landscape"
                alt="Notre Mission"
                className="w-full h-[500px] object-cover object-top rounded-3xl shadow-2xl"
              />
            </div>

            <div>
              <h2 className="text-5xl font-bold text-black mb-8">
                Notre <span className="text-[#E63946]">Mission</span>
              </h2>
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                Chez <strong>Grande Imprimerie</strong>, notre mission est de fournir des solutions d'impression de haute qualité qui aident nos clients à communiquer efficacement, à renforcer leur image de marque et à atteindre leurs objectifs commerciaux.
              </p>
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                Nous nous engageons à offrir un service exceptionnel, des délais de livraison rapides et un accompagnement personnalisé pour chaque projet, qu'il s'agisse d'une petite commande ou d'une production à grande échelle.
              </p>
              <div className="grid grid-cols-2 gap-6 mt-8">
                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <div className="w-12 h-12 bg-[#E63946]/10 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-award-line text-[#E63946] text-2xl"></i>
                  </div>
                  <h3 className="text-black text-xl font-bold mb-2">Qualité Premium</h3>
                  <p className="text-gray-600 text-sm">Excellence dans chaque impression</p>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <div className="w-12 h-12 bg-[#E63946]/10 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-time-line text-[#E63946] text-2xl"></i>
                  </div>
                  <h3 className="text-black text-xl font-bold mb-2">Rapidité</h3>
                  <p className="text-gray-600 text-sm">Livraison sous 24-48h</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-gray-500 text-sm tracking-widest uppercase mb-4 block">NOS VALEURS</span>
            <h2 className="text-5xl font-bold text-black mb-4">
              Ce Qui Nous Définit
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                icon: 'ri-star-line',
                title: 'Excellence',
                description: 'Nous visons l\'excellence dans chaque projet, en utilisant des équipements de pointe et des matériaux de qualité supérieure.'
              },
              {
                icon: 'ri-heart-line',
                title: 'Satisfaction Client',
                description: 'La satisfaction de nos clients est notre priorité. Nous écoutons, conseillons et accompagnons à chaque étape.'
              },
              {
                icon: 'ri-lightbulb-line',
                title: 'Innovation',
                description: 'Nous restons à la pointe des technologies d\'impression et des tendances du marché pour offrir les meilleures solutions.'
              },
              {
                icon: 'ri-shield-check-line',
                title: 'Fiabilité',
                description: 'Respect des délais, qualité constante et transparence totale dans nos engagements envers nos clients.'
              },
              {
                icon: 'ri-team-line',
                title: 'Expertise',
                description: 'Une équipe de professionnels expérimentés dédiée à la réussite de vos projets d\'impression et de branding.'
              },
              {
                icon: 'ri-leaf-line',
                title: 'Responsabilité',
                description: 'Engagement pour des pratiques éco-responsables et utilisation de matériaux respectueux de l\'environnement.'
              }
            ].map((value, index) => (
              <div
                key={index}
                className="bg-[#F8F9FA] rounded-2xl p-8 hover:bg-gradient-to-br hover:from-[#E63946] hover:to-[#d32f3c] group transition-all duration-300 hover:-translate-y-2"
              >
                <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${value.icon} text-[#E63946] text-3xl`}></i>
                </div>
                <h3 className="text-black text-2xl font-bold mb-4 group-hover:text-white transition-colors">
                  {value.title}
                </h3>
                <p className="text-gray-700 text-base leading-relaxed group-hover:text-white transition-colors">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Expertise Section */}
      <section className="py-20 bg-gradient-to-br from-black via-[#2D3142] to-black">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="text-[#E63946] text-sm tracking-widest uppercase mb-4 block">NOTRE EXPERTISE</span>
              <h2 className="text-white text-5xl font-bold mb-8">
                Plus de 10 Ans<br />
                d'Expérience
              </h2>
              <p className="text-gray-300 text-lg leading-relaxed mb-6">
                Depuis notre création, <strong>Grande Imprimerie</strong> s'est imposée comme un acteur majeur dans le domaine de l'impression professionnelle en Afrique.
              </p>
              <p className="text-gray-300 text-lg leading-relaxed mb-8">
                Notre expertise couvre tous les aspects de l'impression, du design graphique au branding complet, en passant par l'accompagnement marketing digital pour aider nos clients à développer leur présence en ligne.
              </p>

              <div className="space-y-4">
                {[
                  'Impression tous supports : papier, textile, grand format',
                  'Design graphique et création d\'identité visuelle',
                  'Branding et stratégie de marque',
                  'Accompagnement e-commerce et vente en ligne',
                  'Solutions marketing digital intégrées'
                ].map((item, index) => (
                  <div key={index} className="flex items-start gap-4">
                    <div className="w-6 h-6 bg-[#E63946] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <p className="text-gray-300 text-base">{item}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="grid grid-cols-2 gap-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center">
                <p className="text-[#E63946] text-5xl font-black mb-3">500+</p>
                <p className="text-gray-300 text-base">Clients Satisfaits</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center">
                <p className="text-[#E63946] text-5xl font-black mb-3">10+</p>
                <p className="text-gray-300 text-base">Ans d'Expertise</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center">
                <p className="text-[#E63946] text-5xl font-black mb-3">5000+</p>
                <p className="text-gray-300 text-base">Projets Réalisés</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center">
                <p className="text-[#E63946] text-5xl font-black mb-3">24h</p>
                <p className="text-gray-300 text-base">Livraison Express</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-[#F8F9FA]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-black text-5xl font-bold mb-6">
            Travaillons Ensemble
          </h2>
          <p className="text-gray-700 text-lg mb-10">
            Découvrez comment Grande Imprimerie peut vous aider à atteindre vos objectifs
          </p>
          <div className="flex flex-wrap gap-5 justify-center">
            <Link
              to="/commande-devis"
              className="bg-[#E63946] text-white px-10 py-4 rounded-full font-bold text-base shadow-2xl hover:bg-[#d32f3c] transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              Demander un Devis
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/contact"
              className="border-2 border-black text-black px-10 py-4 rounded-full font-bold text-base hover:bg-black hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Contactez-nous
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;